<div class="layout-row full-height">
  <div class="flex flex-row flex-60 progress">
    <div class="progress-bar" [ngClass]="isDisableSeverity ? undefined : severity" role="progressbar"
         [style.width.%]="value ?? 0"
         aria-valuemin="0"
         aria-valuemax="100">
    </div>
  </div>
  <span class="value-display" *ngIf="showValue">{{ (value | number: '1.0-0' ) + unit}}</span>
</div>
